
import { Component, Vue, Watch } from "vue-property-decorator";

import FormBase from "@/lib/view-base/formbase";
import { CarouselService, UpdateCarouselDto } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
@Component({
    name: "UpdateProduc",
    components: {
        SelectTree,
    },
})
export default class CreateTenant extends FormBase {
    carousel: UpdateCarouselDto = new UpdateCarouselDto();
    carouselService: CarouselService = new CarouselService();
    productCategoryType: any = [];
    rules: object = {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
       productId: [
            { required: true, message: "请选择选择产品", trigger: "blur" },
        ],

        introduction: [],
        isRegisterd: [],
        organizationUnitId: [],
    };
    buttonlist: any = []
    defaultProps = {
        parent: "parentId", // 父级唯一标识
        value: "id", // 唯一标识
        label: "displayName", // 标签显示
        children: "children",
    };
    options=[ // 下拉选项数组
        { label: '滚动图', value: '1' },
        { label: '直播图', value: '2' },
        // 可以继续添加更多选项
    ]
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    CarouselImg = ''
    mounted() {



        this.getCarousel(+this.$route.params["id"]);
    }
    async getCarousel(id: number) {
        this.initProduct();
        let Carousel = await this.carouselService.get(id);
        this.carousel = <UpdateCarouselDto>Carousel;

        this.carousel.p_Path = (this as any).$aes.imgAddAuth(this.carousel.p_Path)



    }


    created() { }
    async submitExecute(): Promise<void> {
        this.carousel.p_Path = (this as any).$aes.imgDelAuth(this.carousel.p_Path)
        await this.carouselService.update(this.carousel);
    }
    handleSuccess(response, file, fileList) {
        this.carousel.p_Path = (this as any).$aes.imgAddAuth(response.result.url)

    }

    //获取商品分类的数据
    initProduct() {
        var _that = this;
        this.carouselService.getProductAll().then(res => {
            _that.productCategoryType = res;
        });
    }
    handleFaceUpladSuccess(url) {
        this.carousel.p_Path = url
        // this.$set(this.model, 'coverImageUrl', url)
    }

    handleRemove(file, fileList) {
        // 移除图片时更新列表
        //   this.Carousel.imageList = this.Carousel.imageList.filter(img => img.p_Path !== file.);
    }


}
